var Cookies = require('js-cookie');

export const domainManager = (state = {
  cache: {},
  tryingToFetchDomainsByTeam: false,
  addDomainForm: {errors: {}, lastSubmit: {}},
  editDomainForm: {errors: {}, lastSubmit: {}},

}, action) => {

  switch(action.type){
    
    case 'REQUEST_DOMAINS_BY_TEAM':

      return {
        ...state,
        tryingToFetchDomainsByTeam: true
      }

    case 'RECEIVE_DOMAINS_BY_TEAM_FAIL':

      return {
        ...state,
        tryingToFetchDomainsByTeam: false
      }

    case 'RECEIVE_DOMAINS_BY_TEAM_SUCCESS':
      var cache = state.cache;

      cache[action.data.id] = action.data.domains;

      return {
        ...state,
        tryingToFetchDomainsByTeam: false,
        cache: cache,
      }

    
    case 'REQUEST_ADD_DOMAIN':

      return {
        ...state,
        tryingToAddDomain: true,
        addDomainForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_ADD_DOMAIN_FAIL':

      return {
        ...state,
        tryingToAddDomain: false,
        failedToAddDomain: new Date().getTime(),
        addDomainForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_ADD_DOMAIN_SUCCESS':
      var cache = state.cache;

      return {
        ...state,
        tryingToAddDomain: false,
        successfullyAddedDomain: new Date().getTime(),
        addDomainForm: {errors: {}, lastSubmit: {}}
      }


    case 'REQUEST_EDIT_DOMAIN':
      
      return {
        ...state,
        tryingToEditDomain: true,
      }

    case 'RECEIVE_EDIT_DOMAIN_FAIL':
      
      return {
        ...state,
        tryingToEditDomain: false,
        failedtoEditDomain: new Date().getTime()
      }

    case 'RECEIVE_EDIT_DOMAIN_SUCCESS':

      var cache = state.cache;
      for(var i in cache[action.data.team_id]){
        if(cache[action.data.team_id][i].id === action.data.id){
          cache[action.data.team_id][i] = action.data
        }
      }
      
      return {
        ...state,
        cache: cache,
        tryingToEditDomain: false,
        successfullyEditedDomain: new Date().getTime()
      }


    case 'REQUEST_REMOVE_DOMAIN':
      
      return {
        ...state,
        tryingToRemoveDomain: true,
      }

    case 'RECEIVE_REMOVE_DOMAIN_FAIL':
      
      return {
        ...state,
        tryingToRemoveDomain: false,
        failedtoRemoveDomain: new Date().getTime()
      }

    case 'RECEIVE_REMOVE_DOMAIN_SUCCESS':

      var cache = state.cache;
      cache[action.data.team_id] = cache[action.data.team_id].filter(m => m.id !== action.data.id)

      return {
        ...state,
        cache: cache,
        tryingToRemoveDomain: false,
        successfullyRemovedDomain: new Date().getTime()
      }


    default:

      return {
        ...state
      }

      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.domainManager.js